import {
  Bot,
  Calculator,
  FlaskConical,
  Gamepad2,
  NotebookPen,
  SquareStack,
  TrendingUp,
} from "lucide-react";

export const NAV_ITEMS = [
  {
    color: "text-emerald-600 dark:text-emerald-400",
    icon: Bot,
    label: "AI Tutor",
    path: "/ai-tutor",
  },
  {
    color: "text-blue-600 dark:text-blue-400",
    icon: FlaskConical,
    label: "AI Diagnostics",
    path: "/diagnostics",
  },
  {
    color: "text-purple-600 dark:text-purple-400",
    icon: SquareStack,
    label: "AI Flashcards",
    path: "/flashcards",
  },
  {
    color: "text-orange-600 dark:text-orange-400",
    icon: NotebookPen,
    label: "AI Worksheets",
    path: "/worksheets",
  },
  {
    color: "text-cyan-600 dark:text-cyan-400",
    icon: Calculator,
    label: "AI Solver",
    path: "/solver",
  },
  {
    color: "text-pink-600 dark:text-pink-400",
    icon: Gamepad2,
    label: "Games",
    path: "/games",
  },
  {
    color: "text-yellow-600 dark:text-yellow-400",
    icon: TrendingUp,
    label: "Progress",
    path: "/progress",
  },
  // TEMPORARILY HIDDEN SINCE WE HAVE NO USERS
  // {
  //   path: "/leaderboard",
  //   icon: TrendingUp,
  //   label: "Leaderboard",
  //   color: "text-teal-400",
  // },
];
